'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import ProjectTransactionModalRejectController from "./controller/projectTransactionModalreject";
import ReviewedProjectTransactionTableDirective from "./directive/reviewedProjectTransactionTable";
import RejectedProjectTransactionTableDirective from "./directive/rejectedProjectTransactionTable";
import FinalizationProjectTransactionTableDirective from "./directive/finalizationProjectTransactionTable";
import ProjectTransactionService from "./service/projectTransaction";
import ProjectTransactionModalReworkController from './controller/projectTransactionModalRework';

export default angular.module('investmentProject.project.transaction', [])
    .controller('ProjectTransactionModalRejectController', ProjectTransactionModalRejectController)
    .controller('ProjectTransactionModalReworkController', ProjectTransactionModalReworkController)
    .directive('reviewedProjectTransactionTable', ReviewedProjectTransactionTableDirective)
    .directive('rejectedProjectTransactionTable', RejectedProjectTransactionTableDirective)
    .directive('finalizationProjectTransactionTable', FinalizationProjectTransactionTableDirective)
    .factory('ProjectTransactionService', ProjectTransactionService)
    .name;
